import { render, staticRenderFns } from "./ResetSuccessView.vue?vue&type=template&id=9a9b8b4c&scoped=true"
import script from "./ResetSuccessView.vue?vue&type=script&lang=js"
export * from "./ResetSuccessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9b8b4c",
  null
  
)

export default component.exports